import type {Requisition} from './_models'

export const requisitionDetailFields = (detail: Requisition) => ({
  description: detail.description,
  regionId: detail.regionId ?? null,
  regionName: detail.regionName ?? null,
})
